import { EventsHub, deferred } from 'wootils/esm/shared';

class UIMessages extends EventsHub {
  constructor($interval, $q, $sce) {
    'ngInject';

    super();
    this.$interval = $interval;
    this.$q = $q;
    this.$sce = $sce;
    this.popupInfoBaseOptions = {
      title: null,
      message: null,
      deferred: null,
      confirm: false,
      confirmText: 'Accept',
      cancelText: 'Cancel',
      destructive: false,
      html: false,
    };
    this.popupInfo = {};
    this._currentNotificationId = 0;
    this._eventsNames = {
      alert: {
        new: 'app/services/uimessages/alert/new',
        accepted: 'app/services/uimessages/alert/accepted',
        closed: 'app/services/uimessages/alert/closed',
      },
      confirm: {
        new: 'app/services/uimessages/confirm/new',
        accepted: 'app/services/uimessages/confirm/accepted',
        canceled: 'app/services/uimessages/confirm/canceled',
        closed: 'app/services/uimessages/confirm/closed',
      },
      notifications: {
        new: 'app/services/uimessages/notifications/new',
        expired: 'app/services/uimessages/notifications/expired',
      },
    };
  }
  alert(title, content, options = {}) {
    return this._popup(
      title,
      content,
      Object.assign({ confirm: false }, options),
      'Another alert window is already being shown',
      this._eventsNames.alert.new,
    )
    .then((response) => {
      this.emit(this._eventsNames.alert.accepted, response);
      this.emit(this._eventsNames.alert.closed);
      return response;
    });
  }
  onNewAlert(fn) {
    return this.on(this._eventsNames.alert.new, fn);
  }
  onAcceptedAlert(fn) {
    return this.on(this._eventsNames.alert.accepted, fn);
  }
  onClosedAlert(fn) {
    return this.on(this._eventsNames.alert.closed, fn);
  }
  confirm(title, content, options = {}) {
    return this._popup(
      title,
      content,
      Object.assign({ confirm: true }, options),
      'Another confirmation prompt is already being shown',
      this._eventsNames.confirm.new,
    )
    .then((response) => {
      if (response) {
        this.emit(this._eventsNames.confirm.accepted, response);
      } else {
        this.emit(this._eventsNames.confirm.canceled, response);
      }

      this.emit(this._eventsNames.confirm.closed);
      return response;
    });
  }
  onNewConfirm(fn) {
    return this.on(this._eventsNames.confirm.new, fn);
  }
  onAcceptedConfirm(fn) {
    return this.on(this._eventsNames.confirm.accepted, fn);
  }
  onCanceledConfirm(fn) {
    return this.on(this._eventsNames.confirm.canceled, fn);
  }
  onClosedConfirm(fn) {
    return this.on(this._eventsNames.confirm.closed, fn);
  }
  notification(content, options = {}) {
    this._currentNotificationId++;
    const notification = Object.assign({
      id: this._currentNotificationId,
      type: 'success',
      expiration: 3000,
      html: false,
      closeButton: true,
      content,
    }, options);

    if (notification.html) {
      notification.content = this.$sce.trustAsHtml(notification.content);
    }

    this.emit(this._eventsNames.notifications.new, notification);
    if (notification.expiration) {
      let timer = this.$interval(() => {
        this.emit(this._eventsNames.notifications.expired, notification);
        this.$interval.cancel(timer);
        timer = null;
      }, notification.expiration);
    }
  }
  onNewNotification(fn) {
    return this.on(this._eventsNames.notifications.new, fn);
  }
  onExpiredNotification(fn) {
    return this.on(this._eventsNames.notifications.expired, fn);
  }
  _popup(title, content, options, errorMessage, eventName) {
    let result;
    if (this.popupInfo.deferred) {
      result = this.$q.reject(new Error(errorMessage));
    } else {
      const defer = deferred();
      this.popupInfo = Object.assign({}, this.popupInfoBaseOptions, {
        deferred: defer,
        title,
        content,
      }, options);
      this.popupInfo.title = this.$sce.trustAsHtml(this.popupInfo.title);
      this.popupInfo.content = this.$sce.trustAsHtml(this.popupInfo.content);

      this.emit(eventName, this.popupInfo);
      result = defer.promise
      .then((response) => {
        this.popupInfo.deferred = null;
        return response;
      });
    }

    return result;
  }
}

export default UIMessages;
